import request from "./request";

const lang = window.localStorage.getItem('language')

/* 公众号登录 */
export const UserWxlogin = (requestData) => {
  return request({
    url: "/api/user/wxlogin",
    method: "post",
    data: {
      code: requestData
    },
  });
};
/* 图形验证码 */
export const UserWxVerify = (requestData) => {
  return request({
    url: "/api/user/verify",
    method: "post",
  });
};
/* 发送短信 */
export const UserSmsVerify = (requestData) => {
  return request({
    url: "/api/user/sms/verify",
    method: "post",
    data: {

      ...requestData
    },
  });
};
/* 绑定手机号 */
export const UserBindPhone = (requestData) => {
  return request({
    url: "/api/user/bind/phone",
    method: "post",
    data: {
      ...requestData
    },
  });
};
/* 地区接口 */
export const Areas = (requestData) => {
  return request({
    url: "/api/areas",
    method: "post",
    data: {
      lang: lang,
    },
  });
};
/* 保存会员信息 */
export const UserInfoSave = (requestData) => {
  return request({
    url: "/api/user/info/save",
    method: "post",
    data: {
      lang: lang,
      ...requestData
    },
  });
};
/* 获取会员资料 */
export const UserInfo = (requestData) => {
  return request({
    url: "/api/user/info",
    method: "post",
    data: {
      lang: lang,
      token: requestData
    },
  });
};

/* 获取登录二维码URL */
export const WxloginQrcode = () => {
  return request({
    url: "/api/wxlogin/qrcode",
    method: "post",
  });
};
/* 根据票据获取用户信息 */
export const WxloginUser = (requestData) => {
  return request({
    url: "/api/wxlogin/user",
    method: "post",
    data:{
      ticket:requestData
    }
  });
};